import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-342296e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "avatar" }
const _hoisted_2 = { class: "btn" }
const _hoisted_3 = { class: "head pb_5 mb_5" }
const _hoisted_4 = ["href", "onClick"]
const _hoisted_5 = {
  class: /*#__PURE__*/_normalizeClass('item')
}
const _hoisted_6 = {
  key: 0,
  class: "waitFinish"
}
const _hoisted_7 = {
  key: 1,
  class: "fl-r StoreFund flex-col flex-aiend flex-ter"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(")")
const _hoisted_9 = { class: "pt_#1" }
const _hoisted_10 = { class: "logout" }

import { computed, ref } from 'vue'
import { t } from '@/plugins/i18n'
import { logout as logoutApi } from '@/apis/login'
import { useStore } from 'vuex'
import { useRtfix, isD2C, useSite } from '@/store'
import { ElMessage } from 'element-plus'
import router from '@/router'
import UserMsg from './UserMsg.vue'
import { bury } from '@/util/useBury'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { REMOVE_TRIPARTITEUSERINFO } from '@/store/modules/tripartite'
import { calc, getCurrentMonetaryUnit, formatMoneyDirection } from '@/util/useYan'
import { formatPrice } from '@/views/fund/FundList/data'
import bus from '@/util/useBus'
import { useRoute } from 'vue-router'
import { TaEvent, taTrack } from '@/util/buryingPoint'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const getLinkUrl = (urlName: string, params: any) => {
  if (urlName === 'help') {
    const helpUrl = '/' + useSite() + '/help'
    return helpUrl
  }
  return useRtfix(urlName, params ?? undefined)
}

const store = useStore()
const route = useRoute()
const user = computed(() => store.getters.user)

const visible = ref(false)

console.log(user, 'user')

const calAvailableAmount = computed(() => formatMoneyDirection(formatPrice(calc(store.getters['route/getCurShopInfo']?.availableAmount || 0))))
const availableAmount = computed(() => formatPrice((store.getters['route/getCurShopInfo']?.availableAmount || 0)))
/** 埋点信息上报 */
const upReport = (v: any) => {
  bury(v.action)
  taTrack({
    event: TaEvent.BTN_CLICK,
    value: {
      position: v.position
    }
  })
}

const logout = () => {
  bury('PersonPopup_Click_SignOut')
  taTrack({
    event: TaEvent.BTN_CLICK,
    value: {
      position: 'sign_out'
    }
  })
  store.commit(REMOVE_TRIPARTITEUSERINFO)
  setTimeout(() => {
    logoutApi().then(() => {
      store.dispatch('route/changeToken', null)
      ElMessage.success(t('当前账号已退出'))
      // 先清token再回到首页 否则会弹新手引导
      const routerName: any = route.name
      if (routerName?.indexOf('goods_') > -1) {
        // 商品详情退出登录停留在原页面
        location.reload()
        return
      }
      router.replace('/')
    })
  }, 100)
}

// 局部唤起弹窗
bus.on('showPopover', (val) => {
  visible.value = true
})

const list = [
  { label: '登录账号管理', name: 'setupUser', action: 'PersonPopup_Click_Account', position: 'member_info_manage' },
  { label: '店铺采购管理', name: 'setupShop', action: 'PersonPopup_Click_Shop', position: 'purchase_setting' },
  { label: '我收藏的商品和店铺', name: 'CollectProduct', action: 'PersonPopup_Click_FavoriteRecord', position: 'favorite_product_shop' },
  { label: '我买过的商品和店铺', name: 'AfterPurchase', action: 'PersonPopup_Click_PurchaseHistory', position: 'purchased_product_shop' },
  { label: '我看过的商品和店铺', name: 'FootPrint', action: 'PersonPopup_Click_BrowsingHistory', position: 'browsing_history' },
  { label: '我的钱包', name: 'StoreFund', action: 'PersonPopup_Click_MyPurse', position: 'account_list' },
  { label: '帮助', name: 'help', action: 'PersonPopup_Click_Help', params: { query: { tab: 0 } }, position: 'member_center_help' }
].fort()

let timer: any = null
const enter = () => {
  clearTimeout(timer)
  visible.value = true
}
const close = () => {
  timer = setTimeout(() => {
    visible.value = false
  }, 200)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_unref(user))
    ? (_openBlock(), _createBlock(_component_el_popover, {
        key: 0,
        width: 300,
        placement: "bottom",
        trigger: "hover",
        "hide-after": 200,
        offset: 0,
        visible: visible.value
      }, {
        reference: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("div", {
              class: "user",
              onMouseenter: enter,
              onMouseleave: close
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(SvgIcon, {
                  class: "wrap rel",
                  name: "头像"
                })
              ]),
              _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(user)?.loginName), 1),
              _createElementVNode("i", {
                class: _normalizeClass([{ active: visible.value }, 'fa fa-caret-down'])
              }, null, 2)
            ], 32)
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "content",
            onMouseleave: close,
            onMouseenter: enter
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(UserMsg)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (v) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: v.label
              }, [
                (v.name === 'help')
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: getLinkUrl(v.name, v.params ?? undefined),
                      onClick: ($event: any) => (upReport(v))
                    }, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", null, _toDisplayString(v.label), 1)
                        ])
                      ])
                    ], 8, _hoisted_4))
                  : _createCommentVNode("", true),
                (v.name !== 'help')
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: getLinkUrl(v.name, v.params ?? undefined),
                      onClick: ($event: any) => (upReport(v))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(`item ${v.name === 'setupUser' ? 'guideDom-pure-all-6' : ''}`)
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("span", null, _toDisplayString(v.label), 1),
                            (v.name === 'setupUser' && !_unref(user).customerEmail)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(t)('待完善')), 1))
                              : _createCommentVNode("", true),
                            (v.name === 'StoreFund')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                  _createElementVNode("div", null, [
                                    _createTextVNode("(" + _toDisplayString(_unref(t)('店铺余额')) + "：", 1),
                                    _createElementVNode("span", null, _toDisplayString(_unref(availableAmount)) + _toDisplayString(_unref(t)("元")), 1),
                                    _hoisted_8
                                  ]),
                                  _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(calAvailableAmount)), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2)
                      ]),
                      _: 2
                    }, 1032, ["to", "onClick"]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", {
                class: "btn",
                onClick: logout
              }, _toDisplayString(_unref(t)('退出登录')), 1)
            ])
          ], 32)
        ]),
        _: 1
      }, 8, ["visible"]))
    : _createCommentVNode("", true)
}
}

})